export const BASE_URL = process.env.REACT_APP_BASE_URL
export const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY || ''
export const APP_NAME = '@dls'
export const PLAN_SUBSCRIBE_URL =
	'https://pay.hotmart.com/V88318878W?off=2kam54sm&checkoutMode=10&offDiscount=BLOCODAAPROVACAO&sck=RAIOX&bid=1770919242165'
